import React from 'react'
import DashboardSelectionComponent from '../Components/app/dashboard/DashboardSelection';

function DashboardSelection() {
  return <DashboardSelectionComponent />
}

export default DashboardSelection;